import { useTranslation } from 'react-i18next';

import { useGetMissionsQuery } from '@/services/questApi';
import { MissionsError, MissionsList, MissionsLoading } from '@/routes/missioni/MissionsList';

/**
 * Le Missioni — la sezione dei traguardi, nella griglia della Hub.
 *
 * DUE MOSSE, E LA SECONDA E' DI LUCA. CriGio l'ha portata qui dallo Zaino
 * (`9a80a80`, 2026-08-28): lo Zaino tiene quello che PORTI — oggetti,
 * preferenze — mentre una missione e' qualcosa che si fa GIOCANDO, e si guarda
 * dove si decide cosa giocare. Ma quello che aveva disegnato era un MOCKUP con
 * i numeri scritti a mano, e in Hub sarebbe stato in vista: scelta di Luca del
 * 2026-09-09T23:08:39Z (voce L-735, opzione A) ⇒ **in Hub vanno le missioni
 * VERE**, quelle che il giocatore puo' anche riscuotere.
 *
 * ⚠️ NON E' UNA SECONDA SCHERMATA MISSIONI. E' la STESSA di
 * `/settings/missions`, montata in un secondo posto: `MissionsList` e i suoi
 * stati (`MissionsLoading`, `MissionsError`, e il vuoto dentro la lista)
 * arrivano interi da `routes/missioni/`, e il claim che muove denaro resta
 * dov'e', dentro `MissionRow`. Quel giorno che una regola cambia, cambia in un
 * posto solo — che e' esattamente il motivo per cui il mockup e' stato
 * sostituito invece di essere agganciato a sua volta.
 *
 * COSA NON C'E', e non e' una dimenticanza: il titolo e il sottotitolo. Li' e'
 * una sotto-pagina e ha bisogno di dire cosa e'; qui la scheda della Hub porta
 * gia' l'etichetta «Missioni» sopra il pannello, e ripeterla nel corpo la
 * direbbe due volte a due centimetri di distanza.
 *
 * 🔴 QUESTO PANNELLO NON RENDE MAI `null`, e la cosa e' obbligatoria, non
 * elegante: `HubSections` porta la regola nata dal guasto del 2026-09-05 (or45)
 * — *un pannello che puo' renderizzare `null` non deve avere una scheda*,
 * altrimenti l'utente tocca «MISSIONI» e ottiene uno schermo vuoto che non
 * dichiara nemmeno di esistere. Qui i tre rami escono tutti con qualcosa, e
 * `MissionsList` su lista vuota rende `<MissionsEmpty />`, mai il vuoto.
 * Chi aggiungesse un `return null` qui dovrebbe gattare ANCHE il push in
 * `HubSections`, con la stessa condizione.
 *
 * `now` si prende UNA volta per render e si passa in giu': con ogni riga che
 * chiama `new Date()` per conto suo, due missioni con la stessa scadenza
 * possono comparire una scaduta e una no. Stessa ragione, stessa riga, di
 * `routes/missioni/Missions.tsx`.
 */
export function MissionsPanel() {
  const { t } = useTranslation('missions');
  const { data, isLoading, isError, refetch } = useGetMissionsQuery();
  const now = new Date();

  return (
    <div className="flex flex-col gap-6 pb-2">
      {isLoading ? (
        <MissionsLoading />
      ) : isError ? (
        // 401 (resource non concessa) e 403 (scope non richiesti) finiscono entrambi qui, ed
        // e' giusto: per chi guarda sono lo stesso fatto — le missioni non si caricano.
        <MissionsError onRetry={() => void refetch()} />
      ) : (
        <MissionsList missions={data?.missions ?? []} now={now} />
      )}
      {/* La riga che porta alla sotto-pagina non serve: e' la stessa lista. Se un giorno
          questa vista si restringe (solo le riscuotibili, per dire), QUI va il rimando a
          `/settings/missions` — e allora `t('row_hint')` e' la frase gia' scritta. */}
      <span className="sr-only">{t('row_hint')}</span>
    </div>
  );
}
